/* ========================== */
/* ========= import ========= */
/* ========================== */

/* ====== React ====== */
import React, { useEffect, useState } from "react"
import { useLocation } from 'react-router-dom';
/* ====== CSS ====== */
import styled from 'styled-components';


/* ====== Component Js/Jsx ====== */
import { assets } from "03CommonApiParts/Configuration";
import { InputListSearchField, InputSearchFieldA } from "02CommonUiParts/InputParts/InputSearchField";
import { SelectBox } from "02CommonUiParts/InputParts/SelectBox";
import { patternCheckMaster, inputCheckMaster, screenMaster, YEAR_STORAGE, SEARCH_STORAGE } from "03CommonApiParts/CodeDefinition";
import { CFArrayDuplicateCheck, CFArrayFount, CFSort } from "03CommonApiParts/CommonFunction";
import { ButtonClear, ButtonSearch, ButtonSearchNonSubmit, FormatButton, ButtonAllRegister, ButtonIconExcel, ButtonIconEdit, ButtonIconUpload, ButtonIconFormatDownload, ButtonIconRegisterAuthRegister } from "02CommonUiParts/ButtonParts/ButtonBase";
import { InputSearchTimeField } from "02CommonUiParts/InputParts/InputTimeField";
import { TableRadio } from "02CommonUiParts/TableParts/TableRadio";

/* ========================== */
/* ========= Styles ========= */
/* ========================== */

/* ====== Styled Components ====== */
/* ------ ページヘッダー ------*/
// const SdivPageHeaderWrapper = styled.div`//ページヘッダー

//     align-items:center;
//     padding:5px 10px 0px 0;
//     color : #2E94B9;
//     font-weight:bold;
//     white-space: nowrap;
//     margin-left: -10px;
//     width: 100%;

// `;

const SdivSearchWrapper = styled.div`
    align-items: ${props => props.errorsStyle ? 'normal' : 'center'};
    color : #2E94B9;
    font-weight:bold;
    white-space: nowrap;
    margin:8px 0px 0px 0px;
    display:flex;
`;

const SdivContents = styled.div`//ページコンテンツ
	display:flex;
    align-items: ${props => props.errorsStyle ? 'normal' : 'center'};
    flex-wrap:wrap;
    color:black;
    font-weight:normal;
    /* width: 60%; */
`;
const SdivSearchCnt = styled.div`//検索用コンテンツ枠
    padding: 0px 10px 0 0;
    cursor: ${props => props.noEvent ? 'not-allowed' : ''};
    *{
        cursor: ${props => props.noEvent ? 'not-allowed' : ''};
        pointer-events: ${props => props.noEvent ? 'none' : ''};
    }
`;
const SdivGroup = styled.div`
    margin:0 0 0px 0;
    
`;
const SlabelCheckBox = styled.label`//チェックボタン
    color:black;
    font-weight:normal;
`;
const Slabel = styled.label`//チェックボタン
    color:black;
    margin-right: -10px;
    font-weight:normal;
`;
const SpText = styled.p`//テキスト
    margin:0 0 40px 10px;
`;

const SdivGroupRight = styled.div`
    margin:0 0 0px 0;
    
`;

// const SdivSearchCntRight = styled.div`
//     padding: 0px 0px 0 10px;
//     cursor: ${props => props.noEvent ? 'not-allowed' : 'not-allowed'};
// `;

const SdivContents02 = styled.div`
    display:flex;
    margin-left: 60px;
    `;

const SdivGroupCheck = styled.div`
    margin:2px 0 2px 0;
    border: 1px solid #C0C0C0;
    border-radius:3px;
    box-sizing: border-box;
    padding: 0px 10px; 
`;
const SlabelRadio = styled.label`//検索用インプットラベル
    position: absolute;
    left: 0px;
    /* margin: 3px 0; */
    color: ${assets().color.gray};
    pointer-events: none;
    background:white;
    padding:0 3px;
    transform: scale(0.8, 0.8);
`;


/* ========================== */
/* ========== Main ========== */
/* ========================== */

export const SearchField = (props) => {
    /* --------------------------- */
    /* ---------- state  --------- */
    /* --------------------------- */
    const [valiableList, setValiableList] = useState();
    const location = useLocation();
    /* --------------------------- */
    /* -------- variables -------- */
    /* --------------------------- */
    const { payload, register, explain, search, search01, headCells, onClickExcel, onClickBulkUpdate, editMode, errors, payloadData, setDisplayData, dataRow, defaultSearch, setValue  } = props;

    /* ====== sessionStorageからの情報を定義 ====== */
    /* CODEDIFINITION_STORAGEからコード定義を取得 */
    const yearListStorage = sessionStorage.getItem(YEAR_STORAGE);//sessionStorageからコードマスタを取得
    var yearListValue = JSON.parse(yearListStorage);//JSON 文字列を取得し、JavaScriptオブジェクトに変換
    const searchToken = localStorage.getItem(SEARCH_STORAGE);//localStorageから検索キー項目を取得
    var searchValue = JSON.parse(searchToken);//ローカルストレージから検索項目を取得
    /* ========= 月リスト ========= */
    const monthList = [
        { value: '01', label: '1月' },
        { value: '02', label: '2月' },
        { value: '03', label: '3月' },
        { value: '04', label: '4月' },
        { value: '05', label: '5月' },
        { value: '06', label: '6月' },
        { value: '07', label: '7月' },
        { value: '08', label: '8月' },
        { value: '09', label: '9月' },
        { value: '10', label: '10月' },
        { value: '11', label: '11月' },
        { value: '12', label: '12月' },

    ];

    /*====== functions  ======*/
    /* ====== リセット対象を決める ======*/
    const resetTarget = [];
    [...search, ...search01].forEach((item)=>{
        if(item.type === 'input' ||  item.type === 'date' ||  item.type === 'select' ||  item.type === 'checked' || item.type === 'year' || item.type === 'month' || item.type === 'radio' || item.type === 'inputVariableList'){
            resetTarget.push(item.id);
        };
    });
    useEffect(() => {
        search01.forEach((item) => {
            if (item.type === 'inputVariableList') {
                const list = [];
                // dataRow.forEach((row)=>{
                dataRow.forEach((row) => {
                    list.push({
                        value: row[item.id],
                        label: row[item.id2],
                        ord: row[item.ord] ? row[item.ord] : row[item.id]
                    })
                });
                const nonDuplicateList = CFArrayDuplicateCheck(list, 'ord');
                /* 重複を省いて格納 (valueの昇順にソートする)　*/
                setValiableList(CFSort(nonDuplicateList, 'asc', 'ord'));
            }
        });
    }, [search01, dataRow])
    /* ====== inputListのフィルターをかけた時の処理 ======*/
    const onChangeInputList = (e, item) => {
        if (e.target.value) {
            const list = [];
            dataRow.forEach((row) => {
                if (row[item.id] === e.target.value.split(' ')[0]) {
                    list.push(row)
                }
            });

            if (list.length > 0) {
                setValue('payload', list)
                setDisplayData(list);
            } else {
                setValue('payload', []);
                setDisplayData();
            }
        } else {
            setValue('payload',dataRow);
            setDisplayData();
        }

    }
    /* ====== リセットボタンを押した時の処理 ======*/
    const onClickReset = () => {

        //初期値を取得し、検索条件に追加
        const resetObject = {};
        resetTarget.forEach((item) => {
            Object.keys(defaultSearch).forEach(function (key) {
                if (item === key) {
                    resetObject[item] = defaultSearch[key];
                }
            });
        })
        const search = {};
        search[payload] = resetObject;
        setValue(payload, search[payload]);

        /* pathから検索キーの保存先を検索してkeyをセットする */
        searchValue = {
            ...searchValue,
            [CFArrayFount(screenMaster, 'path', location.pathname).id]: search.search
        };

        /* localStorageに検索項目保存 */
        localStorage.setItem(SEARCH_STORAGE, JSON.stringify(searchValue));
    };

    /* ====== テーブル幅計算 ======*/
    let size = 12; //boderやpadding分があるので初期は12;
    headCells?.forEach((item) => {
        size = size + Number(item.width.replace('px', ''));
    });

    /*--------------------------*/
    /*------ Start Render ------*/
    /*--------------------------*/

    return (
        <SdivSearchWrapper errorsStyle={errors.search}>
            <SdivContents errorsStyle={errors.search}>
                {explain ? <SpText className='baseText' style={{ fontSize: assets().size.baseText }}>{explain}</SpText> : <></>}
                {search ? search.map((item, index) =>
                (
                    /* 検索コンテンツ */
                    <div key={`${item.name}${index}`} style={{ margin: '5px 0 5px 0' }}>
                        <SdivSearchCnt key={item.id} noEvent={editMode}>
                            {item.type === 'input' ? //インプット
                                <InputSearchFieldA
                                    error={errors[payload]?.[item.id]?.message}
                                    label={item.name}
                                    maxLength={item.maxLength}
                                    disabled={item.disabled || editMode}
                                    placeholder={item.placeholder}
                                    width={item.width}
                                    register={register(`${payload}.${item.id}`,
                                        {
                                            onChange: (e) => {
                                                if (item.pattern === 'keyword') {
                                                    return setValue(`search.${item.id}`, e.target.value.replace(/\u3000/g, ' '))
                                                } else {
                                                    return null
                                                }
                                            },
                                            required: item.required ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label : '',
                                            minLength: { value: item.minLength ? item.minLength : '', message: CFArrayFount(inputCheckMaster.list, 'value', 'min').label },
                                            require: true,
                                            pattern: {
                                                value: item.pattern ?
                                                    (CFArrayFount(patternCheckMaster.list, 'value', item.pattern)?.detailItemValidationTypeCode ? CFArrayFount(patternCheckMaster.list, 'value', item.pattern)?.detailItemValidationTypeCode : CFArrayFount(patternCheckMaster.list, 'value', 'space')?.detailItemValidationTypeCode) : CFArrayFount(patternCheckMaster.list, 'value', 'space')?.pattern,
                                                message: item.pattern ? CFArrayFount(patternCheckMaster.list, 'value', item.pattern)?.label : CFArrayFount(patternCheckMaster.list, 'value', 'space')?.label
                                            },
                                            validate: {
                                                keyWord: v => {
                                                    if (item.pattern === 'keyword') {

                                                        if (v !== undefined && v !== '' && v !== null) {
                                                            var searchKeyword = v.toString().split(/[\u{20}\u{3000}]/u);
                                                            searchKeyword = searchKeyword.filter(function (item) {
                                                                return item !== '';
                                                            });
                                                            /* スペース以外値が入っていなければスペースエラー */
                                                            if (!v.trim()) {
                                                                return CFArrayFount(patternCheckMaster.list, 'value', 'space').label;
                                                                /* キーワードの件数を5個に制限 */
                                                            } else if (searchKeyword.length > 5) {
                                                                return CFArrayFount(inputCheckMaster.list, 'value', 'keyword').label
                                                            }
                                                        }

                                                    }
                                                }
                                            }

                                        }
                                    )}
                                />
                                : (item.type === 'date' ? //日付
                                    <InputSearchTimeField
                                        error={errors[payload]?.[item.id]?.message}
                                        register={register(`${payload}.${item.id}`,
                                            {
                                                required: item.required ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label : '',
                                                deps: [`${payload}.${item.startDate}`, `${payload}.${item.endDate}`],//startDateとendDateがバリデーション発生した場合同様にエラー表示
                                                validate:
                                                {
                                                    //startDateよりendDateが大きい場合にエラーを発生させる
                                                    invalidDate: v => {
                                                        if (item.startDate) {
                                                            if (v && payloadData?.[item.startDate]) {
                                                                // v > startDate
                                                                if (new Date(v) >= new Date(payloadData?.[item.startDate])) {
                                                                    return true;
                                                                    // v < startDate
                                                                } else {
                                                                    return CFArrayFount(inputCheckMaster.list, 'value', 'date').label;
                                                                }
                                                            };
                                                        } else if (item.endDate) {
                                                            if (v && payloadData?.[item.endDate]) {
                                                                // endDate > v
                                                                if (new Date(payloadData?.[item.endDate]) >= new Date(v)) {
                                                                    return true;
                                                                    // endDate < v
                                                                } else {
                                                                    return CFArrayFount(inputCheckMaster.list, 'value', 'date').label;
                                                                };
                                                            };
                                                        };
                                                    }
                                                },
                                            })}
                                        label={item.name}
                                        disabled={item.disabled}
                                        readOnly={item.readOnly}
                                        defaultValue={item.defaultValue}
                                        width={item.width}
                                        type='date'
                                    />
                                    : (item.type === 'radio' ?
                                        <div style={{ position: 'relative' }}>
                                            <SdivGroupCheck style={{ display: 'flex', height: assets().size.inputHeight }} className={'inputText'}>

                                                {item.range.list.map((itemsChild, index) =>
                                                    <div key={`${itemsChild.value}${index}`}>
                                                        <TableRadio
                                                            key={itemsChild.value}
                                                            id={itemsChild.value}
                                                            label={itemsChild.label}
                                                            disabled={item.disabled}
                                                            value={itemsChild.value}
                                                            defaultChecked={item.defaultChecked === itemsChild.value}
                                                            register={register(`${payload}.${item.id}`,
                                                                item.func ?
                                                                    {
                                                                        onChange: (e) => item.func(e.target.value),
                                                                        required: item.required ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label : '',
                                                                    }
                                                                    :
                                                                    {
                                                                        required: item.required ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label : '',
                                                                    })}
                                                        // readOnly={items.readOnly}
                                                        />
                                                    </div>
                                                )}
                                            </SdivGroupCheck>
                                            <SlabelRadio className='inputlabelText' style={{ fontSize: assets().size.inputlabelText, top: assets().size.inputlabelTop }}>{item.name}</SlabelRadio>
                                        </div>
                                        : (item.type === 'select' ? //セレクト
                                            <SelectBox
                                                label={item.name}
                                                payload={payload} //react-hook-form
                                                register={register(`${payload}.${item.id}`,
                                                    {
                                                        required: item.required ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label : '',
                                                        validate: {
                                                            requireCheck: e => {
                                                                /* requireCheckItemが設定されている時は入力されている時は入力必須になる　*/
                                                                if (!e && payloadData?.[item.requireCheckItem]) {
                                                                    return CFArrayFount(inputCheckMaster.list, 'value', 'required').label;
                                                                }
                                                            }
                                                        }
                                                    }
                                                )}
                                                range={item.range.list} //選択肢
                                                disabled={item.disabled}
                                                width={item.width}
                                                value={item.defaultValue}
                                                errorMessage={errors[payload]?.[item.id]?.message}
                                            />

                                            : (item.type === 'year' ? //セレクト
                                                <SelectBox
                                                    label={item.name}
                                                    payload={payload} //react-hook-form
                                                    register={register(`${payload}.${item.id}`,
                                                        {
                                                            required: item.required ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label : '',
                                                            validate: {
                                                                requireCheck: e => {
                                                                    /* requireCheckItemが設定されている時は入力されている時は入力必須になる　*/
                                                                    if (!e && payloadData?.[item.requireCheckItem]) {
                                                                        return CFArrayFount(inputCheckMaster.list, 'value', 'required').label;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    )}
                                                    range={yearListValue} //年度リスト
                                                    disabled={item.disabled}
                                                    width={item.width}
                                                    value={item.defaultValue}
                                                    errorMessage={errors[payload]?.[item.id]?.message}
                                                />

                                                : (item.type === 'month' ? //セレクト
                                                    <SelectBox
                                                        label={item.name}
                                                        payload={payload} //react-hook-form
                                                        register={register(`${payload}.${item.id}`,
                                                            {
                                                                required: item.required ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label : '',
                                                                validate: {
                                                                    requireCheck: e => {
                                                                        /* requireCheckItemが設定されている時は入力されている時は入力必須になる　*/
                                                                        if (!e && payloadData?.[item.requireCheckItem]) {
                                                                            return CFArrayFount(inputCheckMaster.list, 'value', 'required').label;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        )}
                                                        range={monthList} //月リスト
                                                        disabled={item.disabled}
                                                        width={item.width}
                                                        value={item.defaultValue}
                                                        errorMessage={errors[payload]?.[item.id]?.message}
                                                    />

                                                    : (item.type === 'searchButton' ? //検索ボタン
                                                        <SdivGroup>
                                                            <ButtonSearch lockLeft={true} disabled={editMode} />
                                                        </SdivGroup>
                                                        : (item.type === 'searchButtonNonSubmit' ? //検索ボタン
                                                            <SdivGroup>
                                                                <ButtonSearchNonSubmit className='buttonStyle' onClick={item.func} lockLeft={true} disabled={editMode} />
                                                            </SdivGroup>
                                                            : (item.type === 'clearButton' ? //クリアボタン
                                                                <SdivGroup>
                                                                    <ButtonClear className='buttonStyle' onClick={() => onClickReset()} lockLeft={true} disabled={editMode} />
                                                                </SdivGroup>

                                                                :
                                                                (item.type === 'checked' ?
                                                                    <SdivGroup>
                                                                        <input
                                                                            id={item.id}
                                                                            type='checkbox' //チェックボックス
                                                                            defaultChecked={item.checked}
                                                                            {...register(`${payload}.${item.id}`)} />
                                                                        <SlabelCheckBox htmlFor={item.id} className='baseText' style={{ fontSize: assets().size.baseText }}>{item.name}</SlabelCheckBox>
                                                                    </SdivGroup>
                                                                    : item.type === 'label' ?
                                                                        <SdivGroup>
                                                                            <Slabel>{item.name}</Slabel>
                                                                        </SdivGroup>
                                                                        : (item.type === 'formatDownloadButton' ? //フォーマット出力
                                                                            <SdivGroupRight>
                                                                                <ButtonIconFormatDownload onClick={() => onClickBulkUpdate(item.path)} lockLeft={false} disabled={editMode} />
                                                                            </SdivGroupRight>
                                                                            :
                                                                            <></>))))))))))}

                        </SdivSearchCnt>
                    </div>
                )
                )
                    : <></>}
            </SdivContents>
            <SdivContents02>
                {/* {explain ? <SpText className='baseText' style={{ fontSize: assets().size.baseText }}>{explain}</SpText> : <></>} */}
                {search01 ? search01.map((item, index) => (
                    <SdivSearchCnt key={`${item.id}${index}`} noEvent={editMode} style={{ padding: '5px' }}>
                        {item.type === 'resisterButton' ? //一括登録
                            <SdivGroupRight>
                                <ButtonAllRegister onClick={item.func} lockLeft={false} disabled={editMode} />
                            </SdivGroupRight>
                            : (item.type === 'newRegisterButton' ? //新規登録
                                <SdivGroupRight>
                                    <ButtonIconRegisterAuthRegister onClick={item.func} lockLeft={false} disabled={editMode} />
                                </SdivGroupRight>
                                : (item.type === 'formatButton' ? //フォーマット出力
                                    <SdivGroupRight>
                                        <FormatButton onClick={item.func} style={{ width: assets().size.formatButtonWidth }} lockLeft={false} disabled={editMode} />
                                    </SdivGroupRight>
                                    : (item.type === 'excelButton' ? //フォーマット出力
                                        <SdivGroupRight>
                                            <ButtonIconExcel onClick={() => onClickExcel(item.excelTitle, item.excelConfig)} lockLeft={false} disabled={editMode} />
                                        </SdivGroupRight>
                                        : (item.type === 'formatDownloadButton' ? //フォーマット出力
                                            <SdivGroupRight>
                                                <ButtonIconFormatDownload onClick={() => onClickBulkUpdate(item.path)} lockLeft={false} disabled={editMode} />
                                            </SdivGroupRight>
                                            : (item.type === 'editButton' ? //フォーマット出力
                                                <SdivGroupRight>
                                                    <ButtonIconEdit lockLeft={false} disabled={editMode} />
                                                </SdivGroupRight>
                                                : (item.type === 'inputVariableList' ? //可変のinputList
                                                    <InputListSearchField
                                                        list={item.id}
                                                        label={item.name}
                                                        range={valiableList} //選択肢
                                                        maxLength={item.maxLength}
                                                        width={item.width}
                                                        placeholder={item.placeholder}
                                                        readOnly={editMode}
                                                        errorMessage={errors[payload]?.[item.id]?.message}
                                                        register={register(`${payload}.${item.id}`,
                                                            {
                                                                onChange: (e) => onChangeInputList(e, item),
                                                                required: item.required ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label : '',
                                                                minLength: { value: item.minLength ? item.minLength : '', message: CFArrayFount(inputCheckMaster.list, 'value', 'min').label },
                                                                pattern: {
                                                                    value: item.pattern ? CFArrayFount(patternCheckMaster.list, 'value', item.pattern).detailItemValidationTypeCode : CFArrayFount(patternCheckMaster.list, 'value', 'space').detailItemValidationTypeCode,
                                                                    message: item.pattern ? CFArrayFount(patternCheckMaster.list, 'value', item.pattern).label : CFArrayFount(patternCheckMaster.list, 'value', 'space').label
                                                                },
                                                                validate: {
                                                                    invalidData: v => {
                                                                        if (!v) return;
                                                                        let inputValue = v.split(' ')[0];
                                                                        let inputName = v.substr(inputValue.length + 1);
                                                                        /* リストに存在しない値を入力していた場合はエラー表示 */
                                                                        if (!CFArrayFount(valiableList, 'value', inputValue) || !CFArrayFount(valiableList, 'label', inputName)) {
                                                                            return CFArrayFount(inputCheckMaster.list, 'value', 'invalidInput').label;
                                                                        } else {
                                                                            return;
                                                                        }
                                                                    }
                                                                }
                                                            })}
                                                    />
                                                    : (item.type === 'upload' ? //アップロード
                                                        <SdivGroupRight>
                                                            <ButtonIconUpload
                                                                onClick={item.func}
                                                                onChange={item.onChange}
                                                                lockLeft={false}
                                                                disabled={editMode}
                                                            />
                                                        </SdivGroupRight>
                                                        :
                                                        <></>)))))))}
                    </SdivSearchCnt>
                ))
                    : <></>
                }
            </SdivContents02>

        </SdivSearchWrapper>
    );

}

//使い方

/****** ページヘッダーの設定　*****/
/*------ ページヘッダーの設定 ------*/
    // id         : 項目名
    // name       : 項目名
    // type       : 種類 input/select/checked/searchButton/clearButton
    // range      : selectbox中身
    // type       : 種類 input/select/checked/searchButton/clearButton
    // width      : 幅幅調整用
    // maxLength  : 最大桁数を定義
    // minLength  : 最小桁数を定義
    // placeholder: Input内のテキスト
    // required   : 必須定義
    // disabled   : 操作不可
    // func       : 処理 *button,iconButton,select
    // checked    :defoltCheckを定義

    // /* 検索欄に表示するコンテンツ */
    // const searchContents = [
    //     {id:'inquiryKindLargeClassificationCode',type:'select',range:largeKindRange},
    //     {id:'inquiryKindSmallClassificationCode',type:'select',name:'問合せ種別(小)',range:watchLargeKindCode?categoryCode[watchLargeKindCode]:dammyKindSmall, width:'255px'},
    //     {id:'correspondenceStatus',name:'対応状況ステータス',type:'select',range:statusMaster},
    //     {id:'keyword',type:'input',name:'キーワード',placeholder:'最大5つ(%\'_は不可)',maxLength:100,width:'310px'},
    //     {id:'closedStatus',type:'check',name:'完了・取り下げを含む' ,checked:searchValue ?(searchValue.mainSearchList?(searchValue.mainSearchList.closedStatus === false  ? false:true):true):false },//API修正次第修正　文言は変更した
    //     {id:'search',type:'searchButton'},
    //     {id:'clear',type:'clearButton',func:onClickClear},
    //     {id:'news',type:'check',name:'新着',checked:watchNews},//修正必要　文言は変更した
    //     {id:'resister',type:'resisterButton',func:onClickResister},
    // ];
